import type { PropsWithChildren } from 'react';

import { Typography } from '../ui/Typography';

interface ErrorPageContentProps {
  readonly description: string;
  readonly headline: string;
  readonly title: string;
}

export const ErrorPageContent = ({
  description,
  headline,
  title,
  children,
}: PropsWithChildren<ErrorPageContentProps>) => {
  return (
    <div className="responsive-grid container">
      <div className="col-span-full flex flex-col items-center gap-3 desktop:col-span-6 desktop:col-start-4">
        <Typography
          as="h1"
          responsiveSize="display"
          color="helsinki-blue"
          className="text-center"
        >
          {headline}
        </Typography>
        <Typography
          as="h2"
          responsiveSize="h2"
          color="helsinki-blue"
          className="text-center"
        >
          {title}
        </Typography>
        <Typography
          as="p"
          responsiveSize="bodyLarge"
          color="gray"
          className="py-2 text-center"
          weight="extraLight"
        >
          {description}
        </Typography>
        {children}
      </div>
    </div>
  );
};
